import React from "react";
import { Modal } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { getMarketTradeHourTable } from "src/Requests/marketTradeHour";
import MarketTradeHourModal from "./MarketTradeHourModal";
import { createAdditional } from "./Additional";
import type {
  IMarketTradeHourSearchParams,
  IMarketTradeHourTableReport,
} from "src/Interfaces/marketTradeHour";

enum ModalMode {
  Closed,
  TradeHours,
}

const MarketTradeHour = () => {
  const [modalMode, setModalMode] = React.useState(ModalMode.Closed);
  const [selectedTypeId, setSelectedTypeId] = React.useState<number | null>(
    null,
  );
  const searchParams = {} as IMarketTradeHourSearchParams;

  const additional = React.useMemo(
    () =>
      createAdditional((marketTradeHoursTypeId) => {
        setSelectedTypeId(marketTradeHoursTypeId);
        setModalMode(ModalMode.TradeHours);
      }),
    [],
  );

  const UIModal = React.useMemo(() => {
    if (modalMode === ModalMode.TradeHours && selectedTypeId) {
      return (
        <MarketTradeHourModal
          marketTradeHoursTypeId={selectedTypeId}
          onClose={() => setModalMode(ModalMode.Closed)}
          onSuccess={() => setModalMode(ModalMode.Closed)}
        />
      );
    }
    return null;
  }, [modalMode, selectedTypeId]);

  return (
    <>
      <div className="flex flex-row items-start justify-center gap-3 w-full h-screen px-2 mt-5">
        <div className="w-1/2 !h-full">
          <div className="flex justify-between items-end">
            <span><b>تنظیمات ساعت مجاز برای ارسال سفارش</b></span>
          </div>
          <TableTemplate<
            IMarketTradeHourSearchParams,
            IMarketTradeHourTableReport
          >
            getDataTable={getMarketTradeHourTable}
            TableUI={({ reports, onAction, setSortingType, sortingType }) => (
              <CommonTableUI
                reports={reports}
                sortingType={sortingType}
                setSortingType={setSortingType}
                tableBoxClassName="!mx-0"
                onAction={onAction}
                AdditionalBody={additional}
              />
            )}
            withSort
            pagesize={20}
            searchParameters={searchParams}
          />
        </div>
      </div>

      {modalMode === ModalMode.TradeHours && UIModal ? (
        <Modal UI={UIModal} onClose={() => setModalMode(ModalMode.Closed)} />
      ) : (
        <></>
      )}
    </>
  );
};

export default MarketTradeHour;
